import {
  alpha,
  fontSize,
  fontWeight,
  margin,
  minHeight,
  padding,
  width,
} from "@mui/system";

import { fonts, gutterX, radius } from "../shared/ticketLayout";

const styles = (theme) => ({
  paperContainer: {
    borderRadius: "16px",
    padding: 3,
    display: "flex",
    flexDirection: "column",
    gap: 2,
    position: "relative",
    overflow: "hidden",
  },
  containerHeader: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
  },
  containerTitle: {
    display: "flex",
    flexDirection: "row",
    gap: 0.5,
    flex: 1,
    minWidth: 0,
    alignItems: "center",
  },
  boxFinishAtendimento: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    px: gutterX,
    py: { xs: 2.5, sm: 3.5 },
    gap: 2,
    height: "100%",
  },
  boxActionsFinishAtendimento: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    height: "100%",

    gap: 2,
  },
  boxButtonFinishAtendimento: {
    display: "flex",
    gap: 1.5,
    flexDirection: { xs: "column-reverse", sm: "row" },
    justifyContent: "flex-end",
  },
  titleFinishAtendimento: {
    fontSize: { xs: "1.0625rem", sm: "1.25rem" },
    fontWeight: 700,
    lineHeight: 1.3,
  },
  boxMenuFinishAtendimento: {
    width: "100%",
    display: "flex",
    gap: 1.5,
    flexDirection: { xs: "column", md: "row" },
  },
  boxEdit: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    minHeight: "50px",
    px: gutterX,
  },
  title: {
    fontWeight: "bold",
    fontSize: "18px",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  },
  cardDescricao: {
    fontSize: "13px",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    fontWeight: "bold",
  },
  chipBody: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 0.5,
  },
  nameDescription: {
    fontWeight: "bold",
    fontSize: "12px",
    display: "flex",
    alignItems: "center",
    gap: 0.5,
  },
  valueDescription: {
    fontSize: "12px",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  },
  containerDataDescription: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: 0.5,
  },
  containerButtonEdit: {
    display: "flex",
    gap: 1.5,
    flexDirection: { xs: "column-reverse", sm: "row" },
    justifyContent: "flex-end",
    marginTop: 2,
    marginBottom: 2,
  },
  containerModal: {
    // O translate(-50%, -50%) com top/left 50% vinha de quando isto era um
    // Modal centralizado; dentro do Drawer o efeito se anula, então é só
    // fragilidade. Aqui o container simplesmente preenche o painel.
    position: "relative",
    width: "100%",
    height: "100vh",
    bgcolor: "background.paper",
    pb: 4,
  },
  containerPaper: {
    p: { xs: 1.5, sm: 2 },
    borderRadius: radius.panel,
    height: "100%",
    maxHeight: { xs: "none", md: "700px" },
    backgroundColor: theme.palette.background.wallpaper,
  },
  boxContainerFinish: {
    display: "flex",
    flexDirection: "column",
    gap: 2,
    height: "100%",
    overflowY: "auto",
    p: 1,
  },
  boxTitle: { display: "flex", alignItems: "center", gap: 1 },
  subTitle: {
    fontWeight: 600,
    fontSize: fonts.sectionTitle,
  },
  icon: {
    fontSize: "20px",
  },
  conatinerLoading: {
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  chipStatus: {
    minWidth: "120px",
    color: theme.palette.white.main,
  },
  titleModal: {
    minWidth: 0,
    fontSize: fonts.panelTitle,
    fontWeight: 600,
    lineHeight: 1.3,
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  },
  valueChip: {
    fontSize: "10px",
    fontWeight: "bold",
  },
  containerHeaderModal: {
    display: "flex",
    flexDirection: "column",
    position: "sticky",
    top: 0,
    zIndex: 2,
    backgroundColor: alpha(theme.palette.background.paper, 0.92),
    backdropFilter: "blur(6px)",
    borderBottom: `1px solid ${theme.palette.divider}`,
    px: gutterX,
    py: { xs: 1.5, sm: 2 },
    gap: 1.25,
  },
  headerTopRow: {
    display: "flex",
    alignItems: "center",
    gap: 0.5,
    minWidth: 0,
  },
  headerCloseButton: {
    flexShrink: 0,
    ml: "-6px",
  },
  headerCopyButton: {
    flexShrink: 0,
  },
  headerBottomRow: {
    width: "100%",
    display: "flex",
    flexDirection: { xs: "column", md: "row" },
    alignItems: { xs: "stretch", md: "center" },
    justifyContent: "space-between",
    gap: 1,
  },
  headerChips: {
    display: "flex",
    gap: 0.75,
    flexWrap: "wrap",
    minWidth: 0,
  },
  headerActions: {
    flexShrink: 0,
    alignSelf: { xs: "stretch", md: "auto" },
    "& .MuiButton-root": {
      whiteSpace: "nowrap",
      fontSize: fonts.label,
    },
  },
  titleDescription: {
    fontSize: fonts.sectionTitle,
    fontWeight: 600,
    marginBottom: "5px",
    marginTop: "15px",
    display: "flex",
    alignItems: "center",
    gap: 0.75,
  },
  boxBodyModal: { px: gutterX, py: 1.25 },
  containerBodyModal: { height: "65%", overflowY: "auto" },
  containerPaperModal: {
    width: "100%",
    borderRadius: "16px",
    padding: 2,
    overflowY: "auto",
    display: "flex",
    gap: 1,
    flexWrap: "wrap",
  },
  titleChipModal: {
    fontWeight: 600,
    fontSize: fonts.chip,
    letterSpacing: "0.02em",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  },
  containerDescription: {
    width: "100%",
    minHeight: "60px",
  },
  clearIcon: {
    fontSize: "20px",
    color: theme.palette.text.main,
  },
  buttonDetails: {
    width: "80%",
    color: theme.palette.text.main,
    borderColor: theme.palette.text.main,
  },
  containerPaperMensagem: {
    width: "100%",
    borderRadius: "16px",
    backgroundColor:
      theme.palette.mode === "dark"
        ? theme.palette.colors.black.medium
        : theme.palette.colors.black.lighter,
  },
  boxTextField: { position: "relative", width: "100%" },
  paperItens: {
    height: "79%",
    p: 2,
    overflowY: "auto",
    display: "flex",
    flexDirection: "column",
    borderRadius: "16px",
    gap: 1,
    backgroundColor:
      theme.palette.mode === "dark"
        ? alpha(theme.palette.colors.black.dark, 0.4)
        : theme.palette.colors.black.lighter,
  },
  bodyMensagem: { padding: 2, display: "flex", gap: 2 },
  boxImg: {
    width: "50px",
    height: "50px",
    objectFit: "cover",
    display: "block",
    borderRadius: "8px",
    overflow: "hidden",
    flexShrink: 0,
    flexGrow: 0,
    maxWidth: "50px",
    maxHeight: "50px",
  },
  boxAnexo: {
    width: 100,
    height: 100,
    objectFit: "cover",
    display: "block",
    borderRadius: "8px",
    overflow: "hidden",
    flexShrink: 0,
    flexGrow: 0,
    cursor: "pointer",
  },
  boxTextAnexo: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    display: "block",
  },
  chipTypeAtendimento: {
    maxWidth: { xs: "100%", sm: "180px" },
    height: "24px",
    borderRadius: radius.chip,
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.white.main,
  },
  containerTabs: {
    width: "100%",
    bgcolor: "background.paper",
    px: { xs: 1, sm: 2, md: 3 },
    "& .MuiTab-root": {
      fontSize: fonts.label,
      textTransform: "none",
      fontWeight: 500,
      minHeight: 46,
    },
  },
  chipFluxo: {
    maxWidth: { xs: "100%", sm: "180px" },
    height: "24px",
    borderRadius: radius.chip,
    color: theme.palette.white.main,
  },
  buttonAnexo: {
    width: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    display: "inline-flex",
    justifyContent: "flex-start",
  },
  boxWithoutImg: {
    width: 50,
    height: 50,

    display: "block",
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor:
      theme.palette.mode === "dark"
        ? theme.palette.colors.black.medium
        : theme.palette.colors.black.lighter,
  },
  chip: {
    backgroundColor: theme.palette.cardTrafficData.paperColor.statusUp,
    fontWeight: "bold",
    color: theme.palette.white.main,
    marginLeft: 1,
    flexShrink: 0,
  },
  titleProtocolo: {
    fontSize: "12px",
    fontWeight: "bold",
  },
  boxDescription: {
    display: "flex",
    gap: 1,
  },
  description: {
    fontSize: "13px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    WebkitLineClamp: 3,
    WebkitBoxOrient: "vertical",
    fontWeight: "regular",
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
    color:
      theme.palette.mode === "dark"
        ? theme.palette.colors.black.light
        : theme.palette.colors.black.medium,
  },
  containerInfo: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    gap: 1,
    justifyItems: "center",
  },

  icon: {
    fontSize: "20px",
  },
  boxProtocolo: {
    display: "flex",
    alignItems: "center",
    gap: 0.5,
    mb: "-8px",
  },
  chipFLuxoAtendimento: {
    height: "19px",
    width: "90%",
    fontWeight: "bold",
    fontSize: "10px",
    color: theme.palette.white.main,
  },
  boxIcon: {
    position: "absolute",
    top: 0,
    right: 0,
    minWidth: "40px",
    height: "20px",
    padding: 1,
    borderTopRightRadius: "16px",
    borderBottomLeftRadius: "16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 0.5,
  },
  boxFluxo: {
    position: "absolute",
    top: 0,
    left: 0,
    minWidth: "40px",
    height: "20px",
    padding: 1,
    borderTopLeftRadius: "16px",
    borderBottomRightRadius: "16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 0.5,
  },
  iconStatus: { fontSize: "13px" },
  titleStatusCard: {
    fontSize: "9px",
    fontWeight: 900,
    color: theme.palette.white.main,
  },
  containerButton: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: "auto",
  },
  boxInfos: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: 1,
    minHeight: "150px",
  },
  containerStatusModal: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 0.5,
  },
});

export default styles;
